module.exports = __webpack_public_path__ + "media/hallBgm.05abda97.mp3";